import type { MatchStage } from "@/types/api";

export const STAGE_LABELS: Record<string, string> = {
  GroupStage: "Csoportkör",
  RoundOf32: "Legjobb 32",
  RoundOf16: "Nyolcaddöntő",
  QuarterFinal: "Negyeddöntő",
  SemiFinal: "Elődöntő",
  Final: "Döntő",
  ThirdPlace: "Bronzmérkőzés",
};

/** A választható meccs-szakaszok (ütemezéshez), megjelenítési sorrendben. */
export const ALL_STAGES: MatchStage[] = [
  "GroupStage", "RoundOf32", "RoundOf16", "QuarterFinal", "SemiFinal", "ThirdPlace", "Final",
];

export function stageLabel(stage: MatchStage): string {
  return STAGE_LABELS[stage] ?? stage;
}

export function isGroupStage(stage: MatchStage): boolean {
  return stage === "GroupStage";
}

/** Egy ISO dátum "napi kulcsa" (yyyy-mm-dd, helyi idő szerint) — meccsnap-csoportosításhoz. */
export function dayKey(iso: string): string {
  const d = new Date(iso);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

/** Meccsnap fejléc-formátum, pl. "Június 14., szombat". */
export function formatDayHeading(iso: string): string {
  const d = new Date(iso);
  const s = d.toLocaleDateString("hu-HU", { month: "long", day: "numeric", weekday: "long" });
  return s.charAt(0).toUpperCase() + s.slice(1);
}

/** Csak az idő, pl. "18:00". */
export function formatTime(iso: string): string {
  return new Date(iso).toLocaleTimeString("hu-HU", { hour: "2-digit", minute: "2-digit" });
}
